import { MetadataEntityFieldData, MetadataEntityFieldEditorType, MetadataEntityFieldType } from '../model';


export function getMetadataEntityFieldType(field: MetadataEntityFieldData): MetadataEntityFieldType {
    if (!field?.type) return null;
    return Array.isArray(field.type)
        ? field.type[0]
        : field.type;
}

export function getMetadataEntityFilterType(field: MetadataEntityFieldData): MetadataEntityFieldEditorType {

    if (field?.filterType) return field.filterType;
    const type = getMetadataEntityFieldType(field);

    switch (type) {
        case MetadataEntityFieldType.Date:
        case MetadataEntityFieldType.DateTime:
            return MetadataEntityFieldEditorType.Calendar;

        case MetadataEntityFieldType.Lookup:
        case MetadataEntityFieldType.Tag:
        case MetadataEntityFieldType.Enum:
            return MetadataEntityFieldEditorType.Dropdown;

        case MetadataEntityFieldType.Boolean:
            return MetadataEntityFieldEditorType.Switch;

        case MetadataEntityFieldType.Number:
            return MetadataEntityFieldEditorType.Number;

        default:
            return MetadataEntityFieldEditorType.Input;
    }
}




// export function shouldServerValidateMetadataEntityField(field: MetadataEntityFieldData): boolean {

//     if (field.required) return true;

//     const type = getMetadataEntityFieldType(field);
//     if (!type) return false;

//     switch (type) {
//         case MetadataEntityFieldType.Lookup:
//         case MetadataEntityFieldType.Tag:
//             return true;

//         default:
//             return false;

//     }
// }